/* eslint-disable */
import { Button, List, Tabs } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { ReactElement } from "react";
import ContactInfo from "./ContactInfo";
import MailArhive from "./MailArhive";
import AccountDetail from "./AccountDetail";
import Architectural from "./Architectural";
import Compliances from "./Compliance/Compliances";
import * as React from "react";
import { useStore } from "../../../stores/root-store-context";
import Notes from "./Notes/Notes";
import { observer } from "mobx-react-lite";
import LotDocuments from "./LotDocuments";
import PropertyFaqs from "./Faqs/PropertyFaqs";
import { useIsNarrow } from "Components/TableMui/ResponsiveGrid";
const TableAccountInfo = observer((): ReactElement => {
  const { ricStore } = useStore();
  const tabsShellRef = React.useRef<HTMLDivElement>(null);
  const isMobile = useIsNarrow(768);
  const [tabScroll, setTabScroll] = React.useState({
    left: false,
    right: false,
  });

  React.useEffect(() => {
    const wrap = tabsShellRef.current?.querySelector(".ant-tabs-nav-wrap");
    if (!wrap || typeof MutationObserver === "undefined") {
      return;
    }

    const sync = () => {
      const left = wrap.classList.contains("ant-tabs-nav-wrap-ping-left");
      const right = wrap.classList.contains("ant-tabs-nav-wrap-ping-right");
      setTabScroll((current) =>
        current.left === left && current.right === right
          ? current
          : { left, right }
      );
    };

    const observer = new MutationObserver(sync);
    observer.observe(wrap, { attributes: true, attributeFilter: ["class"] });
    sync();

    return () => observer.disconnect();
  }, []);

console.log(ricStore.contactInformation,"ricStore.contactInformationricStore.contactInformation")
  return (
    <div className="ric__tabs-shell" ref={tabsShellRef}>
    <Tabs
      className="ric__tabs"
      type="line"
      more={{ trigger: ["click"] }}
      tabBarExtraContent={{
        left:
          isMobile && tabScroll.left ? (
            <LeftOutlined
              className="ric__tabs-arrow ric__tabs-arrow--left"
              aria-hidden
            />
          ) : undefined,
        right:
          isMobile && tabScroll.right ? (
            <RightOutlined
              className="ric__tabs-arrow ric__tabs-arrow--right"
              aria-hidden
            />
          ) : undefined,
      }}
      items={[
        {
          label: "Contact Info",
          key: "Contact Info",
          children: (
               <div className="ric-pane">
                 <ContactInfo
                  contactInfo={ricStore.contactInformation}
                />
               </div>
          ),
        },
        {
          label: "Account Detail",
          key: "Account Detail",
          children: <AccountDetail dataSource={ricStore.accountDetails} />,
        },
        {
          label: "Notes",
          key: "Notes",
          children: <Notes />,
        },
        {
          label: "Compliance Issues",
          key: "Compliance",
          children: (
            <div className="ric-pane">
              <Compliances dataSource={ricStore.complianceInformation} />
            </div>
          ),
        },
        {
          label: "Architectural",
          key: "Architectural",
          children: (
            <div className="ric-pane">
              <Architectural
                architecturalData={ricStore.architecturalInformation}
              />
            </div>
          ),
        },
        {
          label: "Mail Archive",
          key: "Mail Archive",
          children: (
            <MailArhive
              mailItems={ricStore.mailArchive}
              openFileCallback={(dataRecordId) => {
                return ricStore.getPdfByDataRecordId(dataRecordId);
              }}
            />
          ),
        },
        {
          label: "Lot Documents",
          key: "Lot Documents",
          children: <LotDocuments />,
        },
        {
          label: " Property FAQs",
          key: " Property FAQs",
          children: (
            <div className="ric-pane">
            <PropertyFaqs companyKey={ ricStore.accountInformation?.companyKey}/>
            </div>
          ),

        }
      ]}
    />
    </div>
  );
});
export default TableAccountInfo;
